import { INVERTER_TYPE, toSystemPowerKwp } from '~/ui-blocks/Equipment/equipment.constants'

export interface HardwareFormInstallationSlice {
  inverter_type?: string | null
  inverters?: Array<{ brand?: string | null }> | null
  microinverters?: Array<string | { brand?: string | null }> | null
  total_powers?: { inverters?: number | null } | null
}

export interface InstallationHardwareDefaults {
  brand: string | null
  systemPowerKw: number
}

function normalizeBrand(brand?: string | null): string | null {
  const trimmed = brand?.trim()
  return trimmed ? trimmed.toLocaleLowerCase() : null
}

function brandFromMicroinverters(
  microinverters: HardwareFormInstallationSlice['microinverters'],
): string | null {
  const first = microinverters?.[0]
  if (!first || typeof first === 'string')
    return null

  return normalizeBrand(first.brand)
}

export function mapHardwareFormToInstallationDefaults(
  form?: HardwareFormInstallationSlice | null,
): InstallationHardwareDefaults {
  const systemPowerKw = toSystemPowerKwp(form?.total_powers?.inverters)
  const isMicro = form?.inverter_type === INVERTER_TYPE.MICROINVERTER

  const brand = isMicro
    ? (brandFromMicroinverters(form?.microinverters) ?? normalizeBrand(form?.inverters?.[0]?.brand))
    : normalizeBrand(form?.inverters?.[0]?.brand)

  return { brand, systemPowerKw }
}
